// Logo GMC servi avec WebP en priorité (PNG en fallback navigateurs anciens).
// Fichiers générés par PIL dans public/.
export default function Logo({
  className = "h-12 w-auto object-contain",
  alt = "GMC Rénovation Façade",
}) {
  return (
    <picture>
      <source srcSet="/logo-gmc.webp" type="image/webp" />
      <img
        src="/logo-gmc.png"
        alt={alt}
        width="200"
        height="155"
        decoding="async"
        fetchPriority="high"
        className={className}
      />
    </picture>
  );
}
